const TABLET_SCREEN_WIDTH = 850

export default TABLET_SCREEN_WIDTH
